import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to extract the actual filename from a full file path or URL
 * Example: "716ebe93-f8a5-47de-b29e-ce4094ea7bf0/organisationDocument/Funders-02-10-2025-20-59-23.pdf"
 * Returns: "Funders-02-10-2025-20-59-23.pdf"
 */
@Pipe({
  name: 'filenameExtractor',
  standalone: true
})
export class FilenameExtractorPipe implements PipeTransform {
  transform(path: string): string {
    if (!path) {
      return '';
    }

    // Handle both forward slashes and backslashes
    const parts = path.replace(/\\/g, '/').split('/');

    // Return the last part (the actual filename)
    return parts[parts.length - 1] || path;
  }
}
